/**
 * Prefer API error message; fall back to a hardcoded string.
 * @param {unknown} error
 * @param {string} [fallback='Something went wrong.']
 * @returns {string}
 */
export function getApiErrorMessage(error, fallback = 'Something went wrong.') {
  if (error == null) return fallback;

  if (typeof error === 'string') {
    const trimmed = error.trim();
    return trimmed || fallback;
  }

  const data = error?.response?.data;
  const candidates = [
    data?.message,
    typeof data?.error === 'string' ? data.error : data?.error?.message,
    error?.message,
    typeof error?.error === 'string' ? error.error : error?.error?.message,
  ];

  for (const candidate of candidates) {
    if (typeof candidate !== 'string') continue;
    const trimmed = candidate.trim();
    if (!trimmed) continue;
    if (/^Request failed with status code \d+$/i.test(trimmed)) continue;
    if (trimmed === 'Network Error') continue;
    return trimmed;
  }

  return fallback;
}

export default getApiErrorMessage;
